export default __webpack_public_path__ + "static/media/ufo.d16c0edd.svg";